module.exports = __webpack_public_path__ + "static/media/tailwind-logo.e0c2e25d.png";